import { Composition } from 'remotion';
import {
  SpringPhysics,
  ScrollTriggeredText,
  MagneticButton,
  ScrollProgressBar,
} from '../components/Beyond100Effects';
import { MixedMediaCollage } from '../effects/MediaCollageEffects';
import {
  ImageMasonryGrid,
  ImageGridCollage,
  ImageBrickMosaic,
  ImageRotatingGallery,
  ImageScatteredPhotos,
  ImageFilmStripReel,
  ImageHexagonHoneycomb,
  ImageMagazineSpread,
  ImagePolaroidCorkBoard,
  ImageVinylRecordCrate,
  ImageStampAlbum,
  ImageCoverflow3D,
  ImageConstellationAtlas,
  ImageTarotReveal,
} from '../effects/ImageGridGallery';
import {
  ImageOrigamiUnfold,
  ImageNeonArcade,
  ImageCinemaScopeTrailer,
  ImageCrystalPrism,
  ImageHolographicMuseum,
  ImageLiquidChromeGallery,
  ImageAuroraRibbonGallery,
  ImageVolumetricStageSpotlight,
  ImagePastelDreamBubbles,
  ImageHandmadeScrapbook,
  ImageCozyWindowSnowfall,
} from '../effects/ImageNewTemplates2026';
import { RetroVintageFilter, AdvancedMorphing } from '../effects/Effects118-120';
import { MediaStateAnimations } from '../effects/Effects121-123';
import { LiquidMetal } from '../effects/Effects131-133';
import { GlassmorphismUI, MatrixCodeRain } from '../effects/Effects134-136';
import { SpringPhysicsCard } from '../effects/Effects137-139';
import { SplitTextAnimation } from '../effects/AdvancedAnimationEffects';
import { PythagoreanTheorem } from '../effects/ExcalidrawRenderer';

export const ShowcaseCompositions = () => (
  <>
      {/* 🚀 超越 100 效果 101+ */}
      <Composition
        id="SpringPhysics"
        component={SpringPhysics}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: 'Spring Physics',
          color: '#FFFFFF',
          backgroundColor: '#1a1a2e',
        }}
      />
      <Composition
        id="ScrollTriggeredText"
        component={ScrollTriggeredText}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: 'SCROLL',
          color: '#FFFFFF',
          backgroundColor: '#16213e',
        }}
      />
      <Composition
        id="MagneticButton"
        component={MagneticButton}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: 'Magnetic',
          color: '#FFFFFF',
          backgroundColor: '#2d3436',
        }}
      />      <Composition
        id="ScrollProgressBar"
        component={ScrollProgressBar}
        durationInFrames={90}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: 'Loading...',
          color: '#6366f1',
        }}
      />
      {/* 🎨 2026 新趋势效果 115-117 */}
      <Composition
        id="MixedMediaCollage"
        component={MixedMediaCollage}
        durationInFrames={120}
        fps={30}
        width={1280}
        height={720}
      />
      {/* 🖼️ 图片网格画廊 118-122 */}
      <Composition
        id="ImageMasonryGrid"
        component={ImageMasonryGrid}
        durationInFrames={150}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          columns: 4,
          gap: 14,
          title: 'Curated Gallery',
          subtitle: 'A Masonry Exhibition · Moments in Frame',
        }}
      />
      <Composition
        id="ImageGridCollage"
        component={ImageGridCollage}
        durationInFrames={120}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          rows: 3,
          cols: 3,
        }}
      />
      <Composition
        id="ImageBrickMosaic"
        component={ImageBrickMosaic}
        durationInFrames={150}
        fps={30}
        width={1280}
        height={720}
      />
      <Composition
        id="ImageRotatingGallery"
        component={ImageRotatingGallery}
        durationInFrames={180}
        fps={30}
        width={1280}
        height={720}
      />
      <Composition
        id="ImageScatteredPhotos"
        component={ImageScatteredPhotos}
        durationInFrames={180}
        fps={30}
        width={1280}
        height={720}
      />
      {/* 🎞️ 图片新模板 123-125 */}
      <Composition
        id="ImageFilmStripReel"
        component={ImageFilmStripReel}
        durationInFrames={240}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: 'CINÉMATHÈQUE',
          subtitle: 'Reel No. XXVI · Eight Short Stories',
        }}
      />
      <Composition
        id="ImageHexagonHoneycomb"
        component={ImageHexagonHoneycomb}
        durationInFrames={180}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: 'HEX · COMB',
          subtitle: 'Nine Cells of Light · A Hexagonal Atlas',
        }}
      />
      <Composition
        id="ImageMagazineSpread"
        component={ImageMagazineSpread}
        durationInFrames={210}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          issueTitle: 'MOMENT',
          articleTitle: 'Quiet Hours',
          author: 'by Ellis Wren',
        }}
      />
      {/* 🕵️ 图片新模板 126-128：调查板 / 黑胶 / 集邮册 */}
      <Composition
        id="ImagePolaroidCorkBoard"
        component={ImagePolaroidCorkBoard}
        durationInFrames={210}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          caseTitle: 'CASE FILE · CLASSIFIED',
          caseNumber: 'NO. 2026-04-17 · K-IX',
        }}
      />
      <Composition
        id="ImageVinylRecordCrate"
        component={ImageVinylRecordCrate}
        durationInFrames={240}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          crateTitle: 'VINYL ARCHIVE',
          subtitle: 'Side A · Six Sides of Midnight',
        }}
      />
      <Composition
        id="ImageStampAlbum"
        component={ImageStampAlbum}
        durationInFrames={210}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          albumTitle: 'PHILATELIA · ATLAS OF LIGHT',
          pageLabel: 'Page XXIV · Europe & Asia · 1950-1970',
        }}
      />
      {/* 🎞️ 图片新模板 129-131：3D 封面流 / 星座图集 / 塔罗牌揭示 */}
      <Composition
        id="ImageCoverflow3D"
        component={ImageCoverflow3D}
        durationInFrames={360}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          showcaseTitle: 'SELECTED WORKS',
          showcaseSubtitle: 'Side A · A Coverflow Of Light',
          secondsPerCover: 1.6,
        }}
      />
      <Composition
        id="ImageConstellationAtlas"
        component={ImageConstellationAtlas}
        durationInFrames={240}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          atlasTitle: 'ATLAS CŒLESTIS',
          chapter: 'Chapter IX · The Lantern Constellation',
        }}
      />
      <Composition
        id="ImageTarotReveal"
        component={ImageTarotReveal}
        durationInFrames={240}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: 'ARCANA · CELTIC CROSS',
          subtitle: 'A Reading in Seven Cards · MMXXVI',
        }}
      />

      {/* 🎨 图片新模板（2026-04-18）：折纸 / 霓虹街机 */}
      <Composition
        id="ImageOrigamiUnfold"
        component={ImageOrigamiUnfold}
        durationInFrames={270}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: 'ORIGAMI · 折',
          subtitle: '六帖 · 光阴折叠为页',
        }}
      />
      <Composition
        id="ImageNeonArcade"
        component={ImageNeonArcade}
        durationInFrames={240}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: 'NEON ARCADE',
          subtitle: 'HYPER · RETRO · 2099',
          cabinetName: 'CRT-Ω · CABINET 07',
        }}
      />

      {/* 🎬 图片新模板（2026-04-18 · V2）：宽银幕 / 水晶棱镜 / 全息博物馆 */}
      <Composition
        id="ImageCinemaScopeTrailer"
        component={ImageCinemaScopeTrailer}
        durationInFrames={300}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          filmTitle: 'AURORA',
          tagline: 'A FILM IN FIVE FRAMES',
          studio: 'WREN · CINEMATIQUE',
        }}
      />
      <Composition
        id="ImageCrystalPrism"
        component={ImageCrystalPrism}
        durationInFrames={300}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: 'CRYSTAL',
          subtitle: 'Six Windows of Light · Facets of the Hour',
        }}
      />
      <Composition
        id="ImageHolographicMuseum"
        component={ImageHolographicMuseum}
        durationInFrames={360}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          museumName: 'MUSEUM OF LIGHT',
          subtitle: 'HALL NOVA · EXHIBIT 07',
        }}
      />

      {/* 🪞 图片新模板（2026-04-18 · V3）：液态铬 / 极光丝带 / 体积光剧场 */}
      <Composition
        id="ImageLiquidChromeGallery"
        component={ImageLiquidChromeGallery}
        durationInFrames={480}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: 'LIQUID · CHROME',
          subtitle: 'MERCURY SERIES · MMXXVI',
          secondsPerImage: 2.2,
        }}
      />
      <Composition
        id="ImageAuroraRibbonGallery"
        component={ImageAuroraRibbonGallery}
        durationInFrames={540}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: 'AURORA · LUMEN',
          subtitle: 'NORTHERN CHAPTERS · MMXXVI',
          secondsPerImage: 2.4,
        }}
      />
      <Composition
        id="ImageVolumetricStageSpotlight"
        component={ImageVolumetricStageSpotlight}
        durationInFrames={540}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: 'THEATRVM · LVMEN',
          subtitle: 'A PLAY IN EIGHT ACTS',
          theater: 'THE GRAND HALL · MMXXVI',
          secondsPerImage: 2.2,
        }}
      />

      {/* 🧁 图片新模板（2026-04-18 · V4）：温馨可爱系列 */}
      <Composition
        id="ImagePastelDreamBubbles"
        component={ImagePastelDreamBubbles}
        durationInFrames={300}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: 'Daydream',
          subtitle: '~ a pocket of soft moments ~',
          labels: ['Sweet', 'Happy', 'Dreamy', 'Cozy', 'Lovely'],
        }}
      />
      <Composition
        id="ImageHandmadeScrapbook"
        component={ImageHandmadeScrapbook}
        durationInFrames={300}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: 'My Little Diary',
          subtitle: 'a handmade collection of soft things',
          dateStamp: 'APR · 2026',
          captions: [
            'sunny afternoon ♡',
            'little adventure!',
            'cozy tea time ~',
            'hello little world',
            'best day ever ☆',
          ],
        }}
      />
      <Composition
        id="ImageCozyWindowSnowfall"
        component={ImageCozyWindowSnowfall}
        durationInFrames={480}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: 'Hello, Winter',
          subtitle: 'a little window of warmth',
          secondsPerImage: 2.6,
        }}
      />

      {/* 🔥 新效果 118-120 */}
      <Composition
        id="RetroVintageFilter"
        component={RetroVintageFilter}
        durationInFrames={120}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: 'RETRO',
          filterType: '80s',
          color: '#ff6b9d',
        }}
      />
      {/* ⚠️ 暂时禁用：SVG path 插值不支持，需要重新设计 */}
      {/* <Composition
        id="AdvancedMorphing"
        component={AdvancedMorphing}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: 'MORPH',
          backgroundColor: '#0a0a1a',
        }}
      /> */}

      {/* 🎨 2026 新趋势 121-123 */}
      <Composition
        id="MediaStateAnimations"
        component={MediaStateAnimations}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: 'MEDIA',
          state: 'playing',
        }}
      />
      {/* 🌀 新效果 #126：像素化效果 */}

      {/* 🎨 新效果 #134-136：2026 设计趋势 */}
      <Composition
        id="GlassmorphismUI"
        component={GlassmorphismUI}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          title: 'GLASSMORPHISM',
          subtitle: 'Modern UI Design',
          backgroundColor: '#667eea',
          cardColor: 'rgba(255, 255, 255, 0.1)',
        }}
      />
      <Composition
        id="MatrixCodeRain"
        component={MatrixCodeRain}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: 'MATRIX',
          fontSize: 16,
          primaryColor: '#00ff00',
          backgroundColor: '#000000',
        }}
      />

      {/* ✨ 新效果 #137-139：Remotion 官方灵感 */}
      <Composition
        id="SpringPhysicsCard"
        component={SpringPhysicsCard}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          title: 'Spring Physics',
          subtitle: 'Apple-style animation',
          cardColor: '#ffffff',
          backgroundColor: '#1e1e2e',
          icon: '🍎',
        }}
      />

      {/* 🎨 新效果 #140-142：震撼视觉效果 */}

      {/* 🎨 新效果 #146-148：高级动画效果（2026-03-02 研究） */}
      <Composition
        id="SplitTextAnimation"
        component={SplitTextAnimation}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: 'SPLIT TEXT',
          color: '#00ff88',
          backgroundColor: '#0a0a1a',
          fontSize: 120,
          stagger: 3,
        }}
      />
      {/* 🎨 新效果 #149-151：Motion 灵感效果 - 注释掉未导入的组件 */}
      {/* <Composition
        id="MotionLayoutAnimation"
        component={MotionLayoutAnimation}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="MotionSplitTextReveal"
        component={MotionSplitTextReveal}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="MotionCSSVariableAnimation"
        component={MotionCSSVariableAnimation}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="OpenClawEp2Enhanced"
        component={OpenClawEp2Enhanced}
        durationInFrames={1464}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="MagneticCursor"
        component={MagneticCursor}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="LiquidMorphingBackground"
        component={LiquidMorphingBackground}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TextScrambleEffect"
        component={TextScrambleEffect}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="Particle3DSphere"
        component={Particle3DSphere}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="FluidParticles"
        component={FluidParticles}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="AudioWaveform"
        component={AudioWaveform}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />

      {/* 📚 Excalidraw 教育效果 */}
      <Composition
        id="PythagoreanTheorem"
        component={PythagoreanTheorem}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 🎨 2026-03-02 新效果（基于 WebSearch 趋势） */}
  </>
);
